import { RoleGroupType } from '../rbac';

export enum MessageStatus {
  unread, // 0代表未读
  rea, // 1代表已读
}

// message item
export interface IMessageItem {
  readonly UserName: string;
  readonly id: number;
  readonly Title: string; // 消息标题
  readonly Content: string; // 消息内容
  readonly Type: MessageType; // 消息大类
  readonly ReadInfo: string; // 阅读记录，隔离规则：time__username||time__username
  readonly CreateTime: Date;
  readonly ModifyTime: Date;
  readonly Receiver: string; // 接收消息的用户id，系统消息id为-1
  readonly Sender: string; // 发送消息的用户id，系统消息id为-1
  readonly StudioID: string;
  readonly StudioName: string;
  readonly SubType: MessageSubType; // 消息小类型
}

// 消息大类
export enum MessageType {
  System, // 系统消息
  UserActive, // 用户交互
}

// 消息小类
export enum MessageSubType {
  Default = 0, // 默认

  // 服务开通
  ServiceOpenSuccess = 1150, // 服务开通成功 => 工作室所有成员（截止目前版本成员挂载在工作室下）
  ServiceOpenFail = 1151, // 服务开通失败 => 服务申请人

  // 系统消息
  FunctionRelease = 1000, // 功能上线
  FunctionRevise = 1001, // 功能调整
  Hotfix = 1002, // bug修复
  SystemUpgrade = 1003, // 系统升级

  // 用户交互
  PermissionUp = 1050, // 被移交owner => 变更者双方---调整          从admin生为ownerX
  PermissionDown = 1051, // 从owner降为admin => 变更者双方
  PermissionRemove = 1052, // 被owner移除studio  => 被移除者
  VoluntarilyQuit = 1053, // 主动退出 => 退出人

  // 权限变更
  PermissionAdmin = 1054, // 非owner和admin 权限变更为 admin
  PermissionUserGroupJoin = 1055, // 加入用户组
  PermissionUserGroupRemove = 1056, // 移除用户组
  PermissionChange = 1057, // 用户组权限变动 用户组关联的role或者role关联的permission发生变动
  PermissionScopeChange = 1058, // 用户组scope变动
  MemberPermissionChange = 1062, // 用户权限变更（用于成员列表中编辑成员）

  PermissionStudioDelete = 1059, // 工作室删除，通知该工作室下所有成员
  PermissionGameDelete = 1060, // 游戏删除，通知有该游戏权限的成员
  PermissionEnvDelete = 1061, // 环境删除，通知有该环境权限的成员

  MemberAppJoinFor = 1100, // 申请加入组织<只要有owner/admin权限都可以收到消息>
  MemberAppJoinSuccess = 1101, // 申请通过<主动申请的加入>
  MemberAppJoinReject = 1102, // 申请被拒绝 => 申请者
  AdminInviteMemberSuccess = 1103, // 管理员邀请后登录自动加入

  CompanyCertifiedSuccess = 1120, // 企业，认证成功
  CompanyCertifiedFail = 1121, // 企业，认证失败

  FeeCenterBalanceAlert = 1200, // 费用中心，余额告警

  ServiceSubmitOpenApplySchedule = 1152, // 服务提交开通申请(异步任务) => 接收人（工作室owner、admin、申请人）v1.9.0
  ServiceOpenSuccessSchedule = 1153, // 服务开通成功(异步任务) 在1.9.0中是指服务部署成功 => 接收人（工作室owner、admin、申请人）v1.9.0
  ServiceOpenFailSchedule = 1154, // 服务开通失败(异步任务) 在1.9.0中是指服务部署失败或者admin拒绝开通 => 服务申请人 v1.9.0
}

export interface ISystemMessageReq {
  readonly Title: string;
  readonly Content: string;
  readonly Type: MessageType;
  readonly SubType: MessageSubType;
  readonly ReadInfo?: string;
  readonly StudioID?: string;
  readonly Sender?: string;
  readonly Receiver?: ReadonlyArray<string>;
}

export type PermissionMessageInfo = {
  readonly authType: RoleGroupType;
  readonly data: PermissionMessageData;
};

export type CompanyMessageInfo = {
  readonly studioName: string;
};

export type PermissionMessageData = ReadonlyArray<{
  groupID: number;
  groupName: string;
}>;

export interface IMessageServiceOpen {
  readonly GameName: string;

  // 当类型是: ServiceSubmitOpenApplySchedule/ServiceOpenSuccessSchedule/ServiceOpenFailSchedule 前端直接展示结果，后端已拼接好服务和子服务
  readonly ServiceName: string;
  readonly EnvName: string;
}
